export default "__VITE_ASSET__7f3b4c54__"